import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-base pt-8" }
const _hoisted_2 = {
  key: 0,
  class: "bg-blue-600 text-center py-9 max-sm:px-9 px-32 rounded-lg max-w-2xl m-auto"
}
const _hoisted_3 = { class: "text-white text-3xl" }
const _hoisted_4 = { class: "text-white mb-8" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "bg-blue-50 border border-blue-200 rounded-full py-1 px-2 w-[90px] text-center text-blue-600 text-xs font-medium" }
const _hoisted_7 = { class: "text-gray-900 text-sm" }
const _hoisted_8 = {
  key: 0,
  class: "flex items-center justify-center gap-1 text-gray-700 font-medium"
}
const _hoisted_9 = {
  key: 1,
  class: "text-gray-700 font-medium flex items-center justify-center gap-1"
}
const _hoisted_10 = {
  key: 0,
  class: "text-white mb-8"
}

import { ref, computed, onMounted } from "vue";
import { useSchoolStore } from "@/stores/schoolStore";
import { useRolloverStore } from "@/stores/rolloverStore";
import UnassignedStudentsTable from "../components/UnassignedStudentsTable.vue";
import { useUserStore } from "@/stores/userStore";
import { useLearnerStore } from "@/stores/learnerStore";
import { SchoolStructureClassGroup } from "@/interfaces/school-structure.interface";
import { useSubjectStore } from "@/stores/subjectStore";
import { useDataStore } from "@/stores/dataStore";
import PageHeaderComponent from "@/components/global/PageHeaderComponent.vue";
import router from "@/router";

// stores

export default /*#__PURE__*/_defineComponent({
  __name: 'AddStudentView',
  setup(__props) {

const schoolStore = useSchoolStore();
const rolloverStore = useRolloverStore();
const userStore = useUserStore();
const learnerStore = useLearnerStore();
const subjectStore = useSubjectStore();
const dataStore = useDataStore();

// NEW CODE START
const studentCounts = ref<{ [key: string]: number }>({});
const loading = ref(false);
const showLearnersBulkUploadProgressModal = ref(false);
const adminClassGroupIds = ref<string[]>([]);
const selectStudentsTable = ref(false);
const selectedClass = ref<SchoolStructureClassGroup | null>(null);
const selectedClassData = ref<SchoolStructureClassGroup | null>(null);

const updateStudentCount = ({ count, classId }: { count: number; classId: string }) => {
  studentCounts.value = { ...studentCounts.value, [classId]: count };
};

onMounted(async () => {
  if (rolloverStore.rollover) {
    rolloverStore.fetchSchoolRollover(rolloverStore.rollover.school);
  }

  const classGroups = schoolStore.getSchoolStructure?.classGroups || [];
  const counts = await Promise.all(
    classGroups.map(async (classGroup) => {
      const learners = await learnerStore.getLearnersByClassId(classGroup._id);
      return { classId: classGroup._id, count: learners.length };
    })
  );
  counts.forEach(({ classId, count }) => {
    studentCounts.value[classId] = count;
  });
});

// get teacher classes
const teacherClasses = computed(() => {
  const currentClasses = schoolStore.getSchoolStructure?.classGroups;

  return currentClasses?.filter((item) => {
    if (userStore.getAdminClassGroupIds.includes(item._id)) {
      return true
    }
  });
});

const rollOverClassCounts = computed(() => {
  const learnerAssignmentActions = rolloverStore.rollover?.learnerAssignmentActions;

  // Loop through each learnerAssignmentAction and count the number of newClassGroups
  const classGroupCounts = learnerAssignmentActions?.reduce((acc, action) => {
    action.newClassGroups.forEach((classGroupId) => {
      if (acc[classGroupId]) {
        acc[classGroupId] += 1;
      } else {
        // Otherwise, initialize it with a count of 1
        acc[classGroupId] = 1;
      }
    });
    return acc;
  }, {} as any);

  return classGroupCounts;
});

const allClassesHaveStudents = computed(() => {
  if (!rolloverStore.hasActiveRollover) return false;
  return teacherClasses.value?.every((classes) => rollOverClassCounts.value[classes._id] > 0) ?? false;
});

const showLearnerTable = (classes: any) => {
  if (rolloverStore.hasActiveRollover) {
    // Navigate to AddStudentToClassView
    router.push({
      path: "/main/add-student-to-class/" + classes._id,
    });
  } else {
    selectStudentsTable.value = true;
    selectedClass.value = classes;

    // Filter the currentClasses to find only the data related to the selected class
    selectedClassData.value = schoolStore.getSchoolStructure?.classGroups.find(
      (group) => group.name === classes.name && group.subject === classes.subject
    ) || null;
  }
};

const processReceivedLearners = (learners: any) => {
  // console.log("LEARNERS TO UPLOAD: ", learners);
  submitLearnersForUpload(learners);
};

const submitLearnersForUpload = async (learners: any) => {
  loading.value = true;
  try {
    // Submitting the uploaded learners for bulk creation in the learner store
    let request = await learnerStore.addLearnerToClass(learners, selectedClass.value?._id || '');
    showLearnersBulkUploadProgressModal.value = true;
    console.log("Request: ", request);
    loading.value = false;
  } catch (error) {
    console.error(error);
    loading.value = false;
  }
};

const hideLearnerTable = () => {
  selectStudentsTable.value = false;
  selectedClass.value = null;
  selectedClassData.value = null;
};

const submitNewLearners = async (learners: any) => {
  loading.value = true;
  try {
    // Submitting the uploaded learners for bulk creation in the learner store
    if (selectedClass.value) {
      await learnerStore.addLearnerToClass(learners.learners, selectedClass.value?._id || '');
    }
    loading.value = false;
  } catch (error) {
    console.error(error);
    loading.value = false;
  }

  // data store call
  await dataStore.fetchSchoolStructureData();
};

return (_ctx: any,_cache: any) => {
  const _component_rl_icon = _resolveComponent("rl-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PageHeaderComponent, { pageHeading: 'Students' }),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        (!selectStudentsTable.value && !selectedClass.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("overview_page.rollover_view.header")) + "!", 1),
              _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("overview_page.rollover_view.subheader")), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teacherClasses.value, (classes, id) => {
                return (_openBlock(), _createElementBlock("div", { key: id }, [
                  _createElementVNode("button", {
                    onClick: ($event: any) => (showLearnerTable(classes)),
                    class: "bg-white flex justify-between items-center gap-16 rounded-lg py-2.5 px-8 mb-3 w-full"
                  }, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(classes?.name) + " " + _toDisplayString(_unref(subjectStore).getSubjectNameById(classes?.subject)), 1),
                    _createElementVNode("div", _hoisted_7, [
                      ((studentCounts.value[classes?._id] === 0 && ((rollOverClassCounts.value?.[classes?._id] ?? 0) === 0)))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                            _createTextVNode(_toDisplayString(_ctx.$t("overview_page.rollover_view.add_students")) + " ", 1),
                            _createVNode(_component_rl_icon, {
                              icon: 'rl-plus',
                              title: 'rl plus',
                              "aria-hidden": "true"
                            })
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_9, [
                            _createTextVNode(_toDisplayString((rollOverClassCounts.value?.[classes?._id] ?? 0) > 0 ?  rollOverClassCounts.value?.[classes?._id] : studentCounts.value[classes?._id]) + " " + _toDisplayString(_ctx.$t("overview_page.rollover_view.students")) + " ", 1),
                            _createVNode(_component_rl_icon, {
                              icon: 'rl-plus',
                              title: 'rl plus',
                              "aria-hidden": "true"
                            })
                          ]))
                    ])
                  ], 8, _hoisted_5)
                ]))
              }), 128)),
              (allClassesHaveStudents.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.$t("overview_page.rollover_view.all_teacher_classes_have_at_least_one_student")), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (selectStudentsTable.value && selectedClass.value)
          ? (_openBlock(), _createBlock(UnassignedStudentsTable, {
              key: 1,
              classData: selectedClass.value ? selectedClass.value : {},
              selectedClassData: selectedClassData.value ? selectedClassData.value : {},
              onLearnersToUpload: processReceivedLearners,
              allowedClassGroupIds: adminClassGroupIds.value,
              onHideTable: hideLearnerTable,
              onUpdateSelectedCount: updateStudentCount,
              onNewLearners: submitNewLearners
            }, null, 8, ["classData", "selectedClassData", "allowedClassGroupIds"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})